import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:code',
    name: 'Estimate',
    component: () => import('../views/Estimate.vue')
  },
  {
    path: '/success/:code',
    name: 'Success',
    component: () => import('../views/Success.vue')
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (!to.query.lang) {
    next({
      path: to.path,
      params: to.params,
      query: { ...to.query, lang: from.query.lang || 'it' },
    });
  } else {
    next();
  }
});


export default router
